var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-row',_vm._l((_vm.cards),function(card,i){return _c('developer-dashboard-card',{key:i,attrs:{"title":card.title,"route":card.route}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }